import { createReducer } from "@reduxjs/toolkit";
import { TYPES } from "../../common/constants";

const fetchUserSuitesDone = (_, { payload }) => {
  return {
    ..._,
    userSuiteList: [...payload],
  };
};

const setCurrentUserSuite = (state, { payload }) => {
  return {
    ...state,
    selectedUserSuite: payload,
  };
};

const initialState = {
  selectedUserSuite: {},
  userSuiteList: [],
};

export default createReducer(initialState, {
  [TYPES.FETCH_USER_SUITES]: fetchUserSuitesDone,

  [TYPES.SET_USER_SUITE]: setCurrentUserSuite,
});
